






import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "tlds-table": () =>
      import("@/modules/web_hosting/components/domains/tldsTable.vue"),
    "tlds-table-provider": () =>
      import("@/modules/web_hosting/components/domains/tldsTableProvider.vue")
  }
})
export default class DomainsTldsView extends Vue {}
